import { PromotionsGridView } from '~/components/promotion/grid';
import { PageContainer } from '~/components/page-container';

export function PromotionsGrid() {
	return (
		<PageContainer>
			<PromotionsGridView />
		</PageContainer>
	);
}
